import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { BillingCycle, SubscriptionPlanId } from '../types/subscription';
import { db, functions } from './firebase';

export type XpayOrderScope = 'subscription' | 'student_payment';
export type XpayOrderStatus = 'CREATED' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export interface CreateXpayCheckoutResult {
  orderId: string;
  redirectUrl: string;
}

export interface XpayOrder {
  id: string;
  orderId: string;
  scope: XpayOrderScope;
  teacherId: string;
  studentId?: string;
  paymentId?: string;
  payerId?: string;
  planId?: SubscriptionPlanId;
  cycle?: BillingCycle;
  amountEgp: number;
  baseAmount?: number;
  studentPayableAmount?: number;
  teacherGrossAmount?: number;
  teacherNetAmountBeforeGateway?: number;
  platformGrossRevenue?: number;
  currency: 'EGP';
  xpaySessionId: string;
  xpayPaymentIntentId?: string;
  checkoutUrl?: string;
  status: XpayOrderStatus;
}

export async function createXpaySubscriptionCheckout(
  planId: SubscriptionPlanId,
  cycle: BillingCycle
): Promise<CreateXpayCheckoutResult> {
  const callable = httpsCallable<
    { planId: string; cycle: BillingCycle },
    CreateXpayCheckoutResult
  >(functions, 'createXpaySubscriptionCheckout');
  const result = await callable({ planId, cycle });
  return result.data;
}

export async function createXpayStudentPaymentCheckout(
  teacherId: string,
  paymentId: string
): Promise<CreateXpayCheckoutResult> {
  const callable = httpsCallable<
    { teacherId: string; paymentId: string },
    CreateXpayCheckoutResult
  >(functions, 'createXpayStudentPaymentCheckout');
  const result = await callable({ teacherId, paymentId });
  return result.data;
}

export async function getXpayOrder(orderId: string): Promise<XpayOrder | null> {
  const snapshot = await getDoc(doc(db, 'xpayOrders', orderId));
  return snapshot.exists()
    ? ({ id: snapshot.id, ...snapshot.data() } as XpayOrder)
    : null;
}

export async function redirectToXpay(redirectUrl: string): Promise<void> {
  window.location.assign(redirectUrl);
}
